export interface IUserProfile {
  userId: string;
  customerId: string;
  fullName: string;
  portalLink: string;
  expandedNav: string;
  featureFlags: IFeatureFlagConfiguration[];
  beamerKey?: string;
  userFlowKey?: string;
  knowledgeBaseLink?: string;
  featureDiscussionLink?: string;
  helpdeskLink?: string;
}

export interface IFeatureFlagConfiguration {
  name: string;
  state: FeatureFlagState;
}

export enum FeatureName {
  homePage = 'Home page',
  performanceTab = 'R3: Success Intelligence: Performance tab',
  sentimentTab = 'Sentiment tab',
  objectionsTab = 'R3: Success Intelligence',
  unifiedFilters = 'Unified Filters',
  topicsTab = 'Topics tab',
  isCcaaSFiltersMetricsHidden = 'Hide CcaaS Filters Metrics',
  scoringScorecardsPage = 'Scorecards page',
  scoringSchedulesPage = 'Auto QA Schedules page',
  promptStudioPage = 'Prompt Studio page',
}

export enum FeatureFlagState {
  disabled = 'Disabled',
  enabled = 'Enabled',
  payWall = 'PayWall',
}